import React, { useState, useEffect } from 'react';
import './Hero.css';

// Import AI generation process images
import AiGenerate1 from '../assets/AiGenerate1.jpeg';
import AiGenerate2 from '../assets/AiGenerate2.jpeg';
import AiGenerate3 from '../assets/AiGenerate3.jpeg';
import AiGenerate4 from '../assets/AiGenerate4.jpeg';
import AiGenerate5 from '../assets/AiGenerate5.jpeg';

const aiImages = [AiGenerate1, AiGenerate2, AiGenerate3, AiGenerate4, AiGenerate5];

const Hero: React.FC = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % aiImages.length);
    }, 3000); // Change image every 3 seconds

    return () => clearInterval(interval); // Cleanup interval on component unmount
  }, []);

  return (
    <section className="hero">
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">
              <span className="highlight">Malzemelerini Çek,</span>
              <br />
              Yapay Zeka Saniyeler İçinde Tarifini Hazırlasın.
            </h1>
            <p className="hero-description">
              Ne pişirsem diye düşünme. Elindeki malzemelerin fotoğrafını çek, FoodQuick'in akıllı yapay zekası sana özel yüzlerce tarifi anında sunsun. Mutfakta devrime hazır ol!
            </p>
            <div className="hero-buttons">
              <a href="#download" className="btn btn-primary">
                Ücretsiz İndir ve Başla
              </a>
              <a href="#features" className="btn btn-secondary">
                Daha Fazlasını Keşfet
              </a>
            </div>
            <div className="hero-stats">
              <div className="stat">
                <span className="stat-number">1K+</span>
                <span className="stat-label">Video Tarif</span>
              </div>
              <div className="stat">
                <span className="stat-number">99%</span>
                <span className="stat-label">AI Başarı Oranı</span>
              </div>
              <div className="stat">
                <span className="stat-number">4.9/5</span>
                <span className="stat-label">Kullanıcı Puanı</span>
              </div>
            </div>
          </div>
          <div className="hero-visual">
            <div className="phone-mockup">
              <div className="phone-screen">
                {aiImages.map((image, index) => (
                  <img
                    key={index}
                    src={image}
                    alt={`AI generation process step ${index + 1}`}
                    className={`app-screen-image ${index === currentImageIndex ? 'visible' : ''}`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
